import Q from 'q';

import memoize from 'js/lib/memoize';

import CourseMaterialsPromiseFactories from 'pages/open-course/common/data/courseMaterials';
import Course from 'pages/open-course/common/models/course';
import CourseMaterials from 'pages/open-course/common/models/courseMaterials';
import CoursePromise from 'pages/open-course/common/promises/course';

const courseMaterialsPromiseFactory = (courseSlug: $TSFixMe) => {
  return Q.all([
    CourseMaterialsPromiseFactories.fromSlug(courseSlug),
    CoursePromise.fromSlug(courseSlug, { rawData: true }),
  ])
    .spread(function (courseMaterialsData, courseData) {
      const course = new Course(courseData, { parse: true });

      return {
        courseMaterials: new CourseMaterials(courseMaterialsData, {
          course,
          parse: true,
        }),
        rawCourseMaterials: { courseData, courseMaterialsData },
      };
    })
    .catch((err) => {
      console.error(err);
    });
};
export default courseMaterialsPromiseFactory;
export const memoizedCourseMaterialsPromiseFactory = memoize(courseMaterialsPromiseFactory);
